import { Link } from 'react-router-dom';

const curriculum = [
  {
    title: 'Phase 1: Structure & Semantic HTML (2 Classes)',
    classes: [
      {
        title: 'Class 1: The Anatomy of a Webpage',
        description:
          'How browsers render code, setting up VS Code, and essential HTML tags (<h1>, <p>, <a>, <img>).',
      },
      {
        title: 'Class 2: User Input & Forms',
        description:
          'Creating functional forms with <input>, <label>, and <button>, plus semantic structure (<nav>, <section>, <article>).',
      },
    ],
  },
  {
    title: 'Phase 2: Modern Styling (3 Classes)',
    subtitle: 'Goal: Moving from basic colors to complex layouts efficiently.',
    classes: [
      {
        title: 'Class 3: CSS Fundamentals & The Box Model',
        description:
          'Merging selectors (classes/IDs) with the physics of the web: Padding, Borders, and Margins.',
      },
      {
        title: 'Class 4: Modern Layouts (Flexbox & Grid)',
        description:
          'A "best of both worlds" class. Using Flexbox for rows/columns and Grid for complex 2D containers.',
      },
      {
        title: 'Class 5: Mobile-First & Responsive Design',
        description:
          'Using Media Queries to make sites work on phones. Introduction to CSS variables for easy theme management.',
      },
    ],
  },
  {
    title: 'Phase 3: Logic & Interactivity (4 Classes)',
    classes: [
      {
        title: 'Class 6: JavaScript Basics',
        description:
          'Understanding the "Brain." Variables (let, const), Data types, and basic arithmetic.',
      },
      {
        title: 'Class 7: Control Flow & Functions',
        description:
          'Making decisions with if/else statements and packaging logic into reusable functions.',
      },
      {
        title: 'Class 8: The DOM (Document Object Model)',
        description:
          'Connecting JS to HTML. Learning how to "grab" an element and change its text or color via code.',
      },
      {
        title: 'Class 9: Event Handling',
        description:
          'Making the page "listen." Responding to clicks, scrolls, and keyboard inputs to create a dynamic user experience.',
      },
    ],
  },
  {
    title: 'Phase 4: The Final Build (3 Classes)',
    classes: [
      {
        title: 'Class 10: Capstone Project: Architecture',
        description:
          'Setting up the project files, building the HTML structure, and applying the global CSS styles.',
      },
      {
        title: 'Class 11: Capstone Project: Logic',
        description:
          'Adding JavaScript functionality (e.g., a "To-Do" list logic, a calculator, or a weather fetcher).',
      },
      {
        title: 'Class 12: Git & Deployment',
        description:
          'Version control basics (commit/push) and launching the site live to the world using Vercel or GitHub Pages.',
      },
    ],
  },
];

const WebDevelopmentBasics = () => {
  return (
    <div className="bg-white">
      <div className="bg-blue-700 pt-16 pb-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between gap-4 flex-wrap">
            <h1 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              Web Development Basics
            </h1>
            <Link
              to="/courses"
              className="inline-flex items-center px-4 py-2 rounded-md text-sm font-medium bg-white text-blue-700 hover:bg-blue-50"
            >
              Back to Courses
            </Link>
          </div>
          <p className="mt-4 text-blue-100 max-w-3xl">
            A 12-class program that teaches HTML, CSS, JavaScript, and deployment through a capstone project.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-12">
          {curriculum.map((phase) => (
            <div key={phase.title}>
              <h2 className="text-2xl font-bold text-gray-900">{phase.title}</h2>
              {phase.subtitle ? (
                <p className="mt-2 text-sm text-gray-600">{phase.subtitle}</p>
              ) : null}

              <div className="mt-6 grid gap-6">
                {phase.classes.map((cls) => (
                  <div key={cls.title} className="rounded-lg border border-gray-200 bg-white shadow-sm">
                    <div className="p-6">
                      <h3 className="text-xl font-semibold text-gray-900">{cls.title}</h3>
                      <p className="mt-3 text-sm text-gray-600">{cls.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WebDevelopmentBasics;
